<template>
    <div>
        <div class="tableDiv">
            <h4>Vitamin E Data</h4>
            <table id="DerivedVitaminTable" class="table" style="width:100%" />
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Router from "vue-router";
import VitaminRawVariable from "@/assets/json/vitamin-raw-variable.json";
Vue.use(Router);

export default {
    props: ["PalmId", "TrialId", "ProgenyId"],
    data() {
        return {
            tableId: "DerivedVitaminTable",
        };
    },
    mounted() {
        this.$nextTick(function() {
            this.drawTable();
        });
    },
    methods: {
        drawTable() {
            var self = this;
            $("#DerivedVitaminTable").DataTable(dataTableOption({
                "ajax": {
                    "url": "VitaminData/GetAll",
                },
                "data": {
                    PalmId: self.PalmId,
                    TrialId: self.TrialId,
                    ProgenyId: self.ProgenyId,
                },
                "columnDefs": [
                    { targets: "_all", defaultContent: "-" },
                    { targets: [3],
                        render: function( data, type, row, meta ) { 
                            if (data) {
                                return parseFloat(Math.round(data * 100) / 100).toFixed(2); 
                            }
                        }
                    }, 
                ],
			        "columns": [
					   	{ data: "palm.trialPalmNumber", title: "Palm No", render: function( data, type, row, meta ) { return "<a href='/palm/palm-details/" + row.palmId + "' class='tableLinkID' data-passingID=" + row.palmId + " data-detailPage='PalmDetail'>" + data + "</a>"; } },
                    { data: "", title: "Palm ID", render: function( data, type, row, meta ) { 
                        return self.arrangePassportFormat(row.palm.trial, row.palm.trialPalmNumber, row.palm.progeny);
                    } },   
                    { data: "status", title: "Status" },
					   	...VitaminRawVariable,
					   	{ data: "recordDate", title: "Record Date", render: function(date) { return self.formatDate(date); } },
					   	{ data: "creationTime", title: "Created At", render: function(date) { return self.formatCreationTime(date); } },
				   	],
				   	"exportTitle": "Derived Vitamin E Data",
            }));
            this.tableLinkID("#DerivedVitaminTable", "/palm/palm-details/");
        },
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Palm/PalmDerivedData/DerivedVitaminTable.vue